import React from "react";
import { ArrowUpOutlined, ArrowDownOutlined, TrophyOutlined } from "@ant-design/icons";
import GamePage from "./GamePage";

const HigherOrLower: React.FC = () => (
    <GamePage
        game="higherOrLower"
        tagColor="gold"
        instructionIcons={[
            <ArrowUpOutlined key="draw" />,
            <ArrowDownOutlined key="predict" />,
            <TrophyOutlined key="reward" />,
        ]}
    />
);

export default HigherOrLower;
